export default [
  {
    _name: 'CSidebarNav',
    _children:
    JSON.parse(window.sessionStorage.getItem('ModuleList'))
  }
]